import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavBarComponent } from './nav-bar.component';
import { RouterModule } from '@angular/router';
import { SideMenuComponent } from './side-menu/side-menu.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { KlProfileImageUploadModule } from 'ui-components';

@NgModule({
  declarations: [NavBarComponent, SideMenuComponent],
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    KlProfileImageUploadModule
  ],
  exports:[NavBarComponent]
})
export class NavBarModule { }
